// extracted by mini-css-extract-plugin
module.exports = {"login__screen":"Forgot_login__screen__1WwD7"};